// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".core-components--app-addr-qr canvas {\n  display: block !important;\n}", ""]);
// Exports
module.exports = exports;
